export default "__VITE_ASSET__pwxj2MnY__"